export const countries = [
  {
    code: "BE",
    name: "Belgium",
  },
  {
    code: "DE",
    name: "Germany",
  },
  {
    code: "NL",
    name: "Netherlands",
  },
  {
    code: "LU",
    name: "Luxembourg",
  },
  {
    code: "SE",
    name: "Sweden",
  },
  {
    code: "FI",
    name: "Finland",
  },
  {
    code: "DK",
    name: "Denmark",
  },
  {
    code: "CH",
    name: "Switzerland",
  },
  {
    code: "HU",
    name: "Hungary",
  },
  {
    code: "IE",
    name: "Ireland",
  },
  {
    code: "AT",
    name: "Austria",
  },
  {
    code: "LT",
    name: "Lithuania",
  },
];

countries.sort((a, b) => a.name.localeCompare(b.name));

export const temperature_status = {
  cold: {
    color: "#479CFF",
    title: "Froid",
  },
  hot: {
    color: "#F43636",
    title: "Chaud",
  },
};

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Device Configuration (same local address for device and dongle config pages)
export const DEVICE_LOCAL_PAGE_URL = 'http://192.168.4.1';

// Video Tutorial
export const USER_DEVICE_SETUP_VIDEO_URL = 'https://drive.google.com/file/d/1neudZ2Yl-dIaqE6Ti0U6FAdQHiIsxEBw/view?usp=sharing';